export default {
  dateSelectorContainer: {
    display: 'flex',
    gap: '1.2rem',
    alignItems: 'stretch',
  },
  dataSelectorChild: {
    flexGrow: 1,
  },
  button: {
    width: '100%',
  },
};
